import React from 'react';
import PropTypes from 'prop-types';
import { Deserializer } from 'jsonapi-serializer';

import ChatMessages from 'api/resources/chatMessages';
import { processErrorByAlert } from 'utils/getErrors';

import { ReactComponent as IconSend } from './IconSend.svg';
import Input from './Input';
import SendButton from './SendButton';

class ChatMessageForm extends React.PureComponent {
  input = React.createRef();

  state = {
    loading: false,
    value: '',
  }

  componentDidMount() {
    this.input.current.focus();
  }

  componentDidUpdate(prevProps) {
    if (this.props.chatRoomId !== prevProps.chatRoomId) {
      this.input.current.focus();
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    try {
      const response = await ChatMessages.create({
        chatRoomId: this.props.chatRoomId,
        include: 'employee,employee.avatar,additional_room,main_room',
        text: this.state.value,
      });

      this.setState({ value: '', loading: false });

      const message = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.props.onSended(message);

      this.input.current.focus();
    } catch (err) {
      this.setState({ loading: false });
      processErrorByAlert(err);
    }
  }

  handleChange = (e) => {
    const { value } = e.target;
    this.setState({ value });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} style={{ position: 'relative' }}>
        <Input
          ref={this.input}
          value={this.state.value}

          type="text"
          placeholder="Напишите сообщение..."
          disabled={this.state.loading}
          required

          onChange={this.handleChange}
        />

        <SendButton
          type="submit"
          disabled={this.state.loading}
          aria-label="Отправить"
        >
          <IconSend />
        </SendButton>
      </form>
    );
  }
}

ChatMessageForm.propTypes = {
  chatRoomId: PropTypes.string,
  onSended: PropTypes.func,
};

ChatMessageForm.defaultProps = {
  chatRoomId: '',
  onSended: () => {},
};

export default ChatMessageForm;
